module.exports = "<div  i18n=\"message | letting the user know that the page they tried to go to does not exist@@PageNotFoundMessage\"> The page you requested was not found. </div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/notfound/notfound.component.html
// module id = ../../../../../src/app/components/notfound/notfound.component.html
// module chunks = main